function isSafari(userAgent: string): boolean {
  return (
    /Safari/.test(userAgent) &&
    !/Chrome/.test(userAgent) &&
    !/Chromium/.test(userAgent)
  )
}

function isChrome(userAgent: string): boolean {
  return /Chrome/.test(userAgent) && !/Edg/.test(userAgent)
}

function isFirefox(userAgent: string): boolean {
  return /Firefox/.test(userAgent)
}

function isEdge(userAgent: string): boolean {
  return /Edg/.test(userAgent)
}

export function extractBrowsers(userAgent: string) {
  return {
    safari: isSafari(userAgent),
    chrome: isChrome(userAgent),
    firefox: isFirefox(userAgent),
    edge: isEdge(userAgent),
  }
}
